import { ErrorMessage, useField } from "formik";
import React from "react";

import QuestionCopy from "./QuestionCopy";
import QuestionWrapper from "./QuestionWrapper";

type TQuestionTextProps = {
  name: string;
  label?: string;
  note?: string;
  type?: "text" | "email";
  error?: boolean;
  inputMode?: "text" | "email" | "search" | "none" | "tel" | "url" | "numeric" | "decimal" | undefined;
};

const QuestionText: React.FC<TQuestionTextProps> = ({
  name,
  label,
  note,
  type = "text",
  error,
  inputMode,
}) => {
  const [field, meta, helpers] = useField(name);

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (
      type === "email" ||
      inputMode === "email" ||
      inputMode === "tel" ||
      inputMode === "numeric" ||
      inputMode === "decimal"
    ) {
      // Strip All White Space
      const value = e.target.value.replaceAll(" ", "");
      helpers.setValue(value);
    } else {
      helpers.setValue(e.target.value);
    }
  };

  return (
    <QuestionWrapper flex>
      <QuestionCopy name={name} label={label} note={note} />
      <input
        style={{
          width: "100%",
          maxWidth: "343px",
          height: "48px",
          borderRadius: "3px",
          backgroundColor: "white",
          color: "#222221CC",
          fontSize: "16px",
          paddingLeft: "1rem",
          border: "1px solid #BDB49F",
          appearance: "none",
          position: "relative",
          outline: error ? "1px solid" : undefined,
          outlineColor: error ? "#D82727" : undefined,
        }}
        type={type}
        inputMode={inputMode}
        {...field}
        onChange={handleFieldChange}
      />
      <ErrorMessage name={name}>
        {(msg) => <p style={{ fontSize: "14px", color: "#D82727", marginBottom: 0 }}>{msg}</p>}
      </ErrorMessage>
    </QuestionWrapper>
  );
};

export default QuestionText;
